import useDebounceEffect from 'ahooks/lib/useDebounceEffect';
import useSafeState from 'ahooks/lib/useSafeState';
import { Alert, Spin } from 'aui';
import React, { useLayoutEffect, useMemo, useState } from 'react';
import { formatMessageWithLocale } from '../../../../../locales';
import { jsonp } from './jsonp';
import { MarkdownSafeMdxViewerLocaleContext } from '../../../../../components/MarkdownSafeMdxViewer/MarkdownSafeMdxViewerLocaleContext';

const loadingEl = (
  <div
    style={{
      height: '32px',
      marginBottom: '1em',
    }}
  >
    <div
      style={{
        display: 'inlineFlex',
        alignItems: 'center',
      }}
    >
      {/* {formatMessageWithLocale({
        id: 'githubGistRenderer.loading.message',
      })} */}
    </div>
  </div>
);
const errorEl = (locale: string) => (
  <div
    style={{
      marginBottom: '1em',
    }}
  >
    <Alert
      message={formatMessageWithLocale(locale, {
        id: 'githubGistRenderer.errorLoading.message',
      })}
      type="error"
    />
  </div>
);
function GistBox(props: { source: string }) {
  const [state, setState] = useSafeState<{
    loading: boolean;
    error: boolean;
    html?: string;
  }>({
    loading: true,
    error: false,
    html: undefined,
  });

  const pathName = (function (e) {
    const { pathname: t } = new URL(e);
    return (t || '').split('/').pop();
  })(props.source);
  const e = `https://gist.github.com/${pathName}.json`;

  const shadowResult = useMemo(() => {
    const shadowDiv = document.createElement('div');
    shadowDiv.className = 'gist-block-shadow-container w-full';
    const shadow = shadowDiv.attachShadow({ mode: 'open' });
    const innerDiv = document.createElement('div');
    shadow.appendChild(innerDiv);
    return {
      shadow,
      shadowDiv,
      innerDiv,
    };
  }, []);

  const html = state.html ?? '';

  useDebounceEffect(() => {
    jsonp<{
      div: string;
      stylesheet: string;
    }>(e).then(
      (n) => {
        setState({
          loading: false,
          error: false,
          html: n.div,
        });
        if (!shadowResult.shadow.querySelector(`link[href="${n.stylesheet}"]`)) {
          const t = document.createElement('link');
          t.type = 'text/css';
          t.rel = 'stylesheet';
          t.href = n.stylesheet;
          shadowResult.shadow.appendChild(t);
        }
      },
      () => {
        setState({
          loading: false,
          error: true,
          html: void 0,
        });
      },
    );
  }, [e]);

  useDebounceEffect(() => {
    shadowResult.innerDiv.innerHTML = html;
  }, [html]);

  const [contentElRef, setContentElRef] = useState<HTMLDivElement | null>(null);
  const contentEl = <div className="gist-block  w-full" ref={setContentElRef} />;

  useLayoutEffect(() => {
    contentElRef?.appendChild(shadowResult.shadowDiv);
    return () => {
      if (contentElRef) {
        contentElRef.innerHTML = '';
      }
    };
  }, [contentElRef, shadowResult.shadowDiv]);

  const locale = React.useContext(MarkdownSafeMdxViewerLocaleContext);

  return (
    <Spin spinning={state.loading} wrapperClassName="w-full">
      {state.error ? errorEl(locale) : state.loading ? loadingEl : contentEl}
    </Spin>
  );
}

export { GistBox };
